module.exports = __webpack_public_path__ + "img/ginny-logo-iso.4183a3f9.svg";